/* eslint-disable max-len */
import { template_translation } from '../lang/TemplateTranslation';
const t = template_translation;

/** 20. CODEモードを使ってみよう */
export const template20 = {
  title: t.to('水槽でお魚を泳がそう！(初級編)', 'title20'),
  desc: t.to(
    `水槽を青い透明なBLOCKで表現し、その中で3Dモデルを左から右へJavascriptのプログラムで移動します`,
    'desc20'
  ),
  img: '../public/template/20.png',
  xml: `<xml xmlns="http://www.w3.org/1999/xhtml">
  <variables>
  </variables>
  <comment id="/nf@NAlV+]3.aELuuZ?A" x="253" y="326" h="550" w="1042">【学べること】
 3Dモデル※の「移動方法の例」を学ぶできます
◆BLOCK部分
 1. 左のBLOCKタブより、"シーンスタート"をドラック＆ドロップします。
 2. 同じく"背景"を持って来て、"シーンスタート"の中に配置します。
 3. 魚を配置するため、右上のファイルメニューからファイル管理を選択し、プリセットから3Dモデルの"Fish02"を選択します。
 4. 魚を動かすため、BLOCKタブより"ID"ブロックを持ってきて、”Fish02”に接続し、「ID=block」を入力します。
 5. 水槽を配置するため、BLOCKタブより"直方体”を持ってきて、「ID=tank」を指定します。
 6. 水槽のデザイン1："直方体”を「色：青」にします。
 7. 水槽のデザイン2：BLOCKタブより"透明度”を持ってきて、透明度を指定します。
 8. 水槽のデザイン3：BLOCKタブより"大きさ”を持ってきて、大きさを指定します。
 ※3Dモデルに代わって直方体/球体のBLOCKを指定することも可能です
◆CODE部分
 A. 初期設定
  1. なし
 B. Loop設定
  1. 移動を「block.object3D.position」で指示します。
  2. 元の位置に戻る条件として「X位置が2まで移動したら、X位置が-2に戻る設定」をif文で指示します。</comment>
  <block type="a-scene-start" x="250" y="70">
    <field name="is_init">off</field>
    <field name="hasController">off</field>
    <statement name="IN">
      <block type="environment_v2">
        <field name="environment">seed: 8; skyType:gradient; skyColor:#24b59f; horizonColor:#eff9b7; lighting:distant; lightPosition:-1.2 0.88 -0.55;fog: 0.8; flatShading: false; playArea: 1; ground:noise; groundYScale: 4.18; groundTexture: squares; groundColor:#937a24; groundColor2:#987d2e; dressing:trees; dressingAmount: 100; dressingColor:#888b1d; dressingScale: 1; dressingVariance:10 10 10; dressingUniformScale: true; dressingOnPlayArea: 0; grid: none; gridColor: #c5a543; shadow: false</field>
        <next>
          <block type="gltf_element_v2">
            <field name="nameField">Fish02.glb</field>
            <field name="src">/public/preset/3DModel/Fish/Fish02.glb</field>
            <field name="position-x">-2</field>
            <field name="position-y">1</field>
            <field name="position-z">0</field>
            <value name="ATTR">
              <block type="id_v2">
                <field name="id">block</field>
                <value name="ATTR">
                  <block type="rotation_v2">
                    <field name="rotation-x">360</field>
                    <field name="rotation-y">90</field>
                    <field name="rotation-z">360</field>
                  </block>
                </value>
              </block>
            </value>
            <next>
              <block type="cube_v2">
                <field name="id">tank</field>
                <field name="position-x">0</field>
                <field name="position-y">1</field>
                <field name="position-z">0</field>
                <value name="COLOUR">
                  <shadow type="color_value_v2">
                    <field name="COLOUR">#4c00ff</field>
                  </shadow>
                </value>
                <value name="ATTR">
                  <block type="a-opacity">
                    <field name="opacity">0.2</field>
                    <value name="ATTR">
                      <block type="scale_v2">
                        <field name="scale-x">6.5</field>
                        <field name="scale-y">3</field>
                        <field name="scale-z">3</field>
                      </block>
                    </value>
                  </block>
                </value>
              </block>
            </next>
          </block>
        </next>
      </block>
    </statement>
  </block>
</xml>

  `,
  js_code: `/* Setup 処理*/
  const block = document.querySelector("#block")
  
  /* Loop 処理*/
  forever(()=>{
      /* 魚を右に移動させる */
      if(block.object3D.position.x < 2){      // 条件：X位置が2より小さい場合の処理
          block.object3D.position.x += 0.01   //   移動：X位置を0.01づつ右に移動する
      }else{                                  // 条件：X位置が2以上の場合
          block.object3D.position.x = -2      //   移動：X位置を-2に移動する
      }
  })
`,
};
